import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

// Text input with a standard show/hide (eye) control. Mirrors the app's plain
// <input> styling; the toggle is accessible (aria-label + aria-pressed).
export function PasswordInput({ value, onChange, placeholder, testId, toggleTestId, autoComplete }) {
  const [show, setShow] = useState(false);
  return (
    <div className="pw-field">
      <input
        data-testid={testId}
        type={show ? "text" : "password"}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
      />
      <button
        type="button"
        className="pw-toggle"
        data-testid={toggleTestId}
        aria-label={show ? "Hide password" : "Show password"}
        aria-pressed={show}
        onClick={() => setShow((s) => !s)}
      >
        {show ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
}
